import type {CatalogMenuGroup, CatalogMenuItem, CatalogMenuRow} from '@/types/View'

export const PROCESSES_ROUTE = 'processes'

export const PROCESSES_MENU_ITEM: CatalogMenuRow = {
  route: PROCESSES_ROUTE,
  labelRu: 'Процессы',
  labelKk: 'Процестер',
}

function hasRoute(items: CatalogMenuItem[], route: string): boolean {
  return items.some(item => 'type' in item && item.type === 'group'
    ? (item as CatalogMenuGroup).items.some(sub => sub.route === route)
    : (item as CatalogMenuRow).route === route)
}

/**
 * Пункт «Процессы» в меню.
 *
 * Постоянное место пункта — строка catalogmenu в БД, как у остальных разделов.
 * Пока её нет, пункт добавляется здесь, а когда строка появится — дубля не
 * будет.
 */
export function withProcessesMenuItem(items: CatalogMenuItem[]): CatalogMenuItem[] {
  if (hasRoute(items, PROCESSES_ROUTE))
    return items
  return [...items, PROCESSES_MENU_ITEM]
}
